import styled from '@emotion/styled'

export const Container = styled.div`
  max-width: 1440px;
  padding: ${({ theme }) => theme.spacing(0, 2)};
  margin: 0 auto;
  height: 100%;
`
